import { Spinner } from '@frontend/elements';

import useProvision from './provision.controller';

export const ID = 'provision';

export enum ProvisionState {
    INIT,
    AUTHENTICATING,
    PERMISSION_CHECK,
    PERMISSION_CHECK_FAILED,
    DONE
}

export interface Props {
    deviceId: string;
    provisionDone?: () => void;
}

const Provision = (props: Props) => {
    const viewProps = useProvision(props);

    return (
        <div id={ID}>
            <div className='text-center m-4'>
                <h4>{viewProps.message}</h4>
                <Spinner show={viewProps.state !== ProvisionState.PERMISSION_CHECK_FAILED} />
            </div>
        </div>
    );
};

export default Provision;
